// extracted by mini-css-extract-plugin
module.exports =  {"button":"d0yEf4L","trigger":"h7StP4b","open":"iqt_cj5","outlined":"cdEPbgB","disabled":"DcQ0kev"};